import { useNavigate } from "react-router-dom";
import { useUser } from "../../../hooks/useUser";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import NotificationListSection from "../../../features/notification/components/NotificationListSection/NotificationListSection";
import { useTranslation } from "react-i18next";

const FirstSection = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useUser();
  const isDesktop = useIsDesktop();
  const { t } = useTranslation("firstPart");

  return (
    <div>
      {/* Hero Section — CTS style: dark bg, 2-column layout */}
      <section
        style={{
          backgroundColor: "#111111",
          width: "100%",
          minHeight: isDesktop ? "480px" : "auto",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            display: "flex",
            flexDirection: isDesktop ? "row" : "column",
            alignItems: "center",
            gap: isDesktop ? "48px" : "24px",
            padding: isDesktop ? "60px 40px" : "32px 20px",
          }}
        >
          {/* Left — YouTube Video */}
          <div
            style={{
              flex: 1,
              width: "100%",
              borderRadius: "12px",
              overflow: "hidden",
              aspectRatio: "16/9",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/JXjvfOprAag?rel=0"
              title="CTS Power Of Protection"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>

          {/* Right — Text Content */}
          <div
            style={{
              flex: 1,
              color: "#fff",
              textAlign: isDesktop ? "left" : "center",
            }}
          >
            {/* WELCOME TO CTS with red line */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                justifyContent: isDesktop ? "flex-start" : "center",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                WELCOME TO CTS
              </span>
              <span
                style={{
                  display: "inline-block",
                  width: "40px",
                  height: "2px",
                  backgroundColor: "#E53E3E",
                }}
              />
            </div>

            <h1
              style={{
                fontSize: isDesktop ? "38px" : "26px",
                fontWeight: 700,
                margin: "0 0 28px 0",
                lineHeight: 1.25,
                color: "#fff",
              }}
            >
              ศูนย์บริการปกป้องสีรถยนต์ ที่รวบรวมนวัตกรรมระดับโลกไว้ในที่เดียว ด้วยมาตรฐาน ISO 9001: 2015
            </h1>

          </div>
        </div>
      </section>

    </div>
  );
};

export default FirstSection;
